/**
 * Maps institution names (from JSON) → logo paths in public/logos/.
 * To swap a placeholder for a real logo, just replace the SVG file - no code change needed.
 */
const LOGO_MAP = {
  // Banks
  'EQ Bank': '/logos/eq-bank.svg',
  'EQ Bank (Equitable Bank)': '/logos/eq-bank.svg',
  'Equitable Bank': '/logos/eq-bank.svg',
  'Wealthsimple': '/logos/wealthsimple.svg',
  'Simplii Financial (CIBC)': '/logos/simplii.png',
  'Simplii Financial': '/logos/simplii.png',
  'Simplii': '/logos/simplii.png',
  'Tangerine (Scotiabank)': '/logos/tangerine.svg',
  'Tangerine': '/logos/tangerine.svg',
  'BMO': '/logos/bmo.svg',
  'BMO Financial Group': '/logos/bmo.svg',
  'RBC': '/logos/rbc-icon.webp',
  'RBC Royal Bank': '/logos/rbc-icon.webp',
  'Royal Bank of Canada': '/logos/rbc-icon.webp',
  'Scotiabank': '/logos/scotiabank.svg',
  'TD Bank': '/logos/td.svg',
  'TD': '/logos/td.svg',
  'CIBC': '/logos/cibc.svg',
  'National Bank of Canada': '/logos/national-bank.svg',
  'National Bank': '/logos/national-bank.svg',
  'Desjardins (Caisse populaire)': '/logos/desjardins.svg',
  'Desjardins': '/logos/desjardins.svg',
  'Neo Financial': '/logos/neo.png',

  // Mortgage insurers
  'CMHC': '/logos/cmhc.svg',
  'Sagen': '/logos/sagen.svg',
  'Canada Guaranty': '/logos/canada-guaranty.svg',

  // Remittances (by name - institutionField is 'type' for this vertical)
  'Wise': '/logos/wise.svg',
  'Wise (TransferWise)': '/logos/wise.svg',
  'Remitly': '/logos/remitly.svg',
  'Simplii Global Money Transfer': '/logos/simplii.png',
  'RBC International Money Transfer': '/logos/rbc-icon.webp',
  'Western Union': '/logos/western-union.svg',

  // Insurance (category icons - matched by name since type is shared)
  'Provincial Health Insurance (RAMQ Quebec / OHIP Ontario / etc.)': '/logos/insurance-health.svg',
  'Private Health Insurance (Waiting Period Gap)': '/logos/insurance-private-health.svg',
  'Tenant / Renters Insurance': '/logos/insurance-home.svg',
  'Auto Insurance': '/logos/insurance-auto.svg',
  'Term Life Insurance': '/logos/insurance-life.svg',

  // GIC providers (matched by provider name from rate tables)
  'WealthONE': '/logos/wealthone.svg',
  'Achieva Financial': '/logos/achieva.svg',
  'Oaken Financial': '/logos/oaken.svg',
  'First Ontario': '/logos/first-ontario.svg',
  'Saven Financial': '/logos/saven.png',
  'MAXA Financial': '/logos/maxa.svg',
  'Outlook Financial': '/logos/outlook.png',
  'Meridian Credit Union': '/logos/meridian.svg',
  'Bridgewater Bank': '/logos/bridgewater.svg',
  'Borrowell': '/logos/borrowell.svg',

  // Registered accounts (matched by name)
  'Tax-Free Savings Account (TFSA / CELI)': '/logos/account-tfsa.svg',
  'Registered Retirement Savings Plan (RRSP / REER)': '/logos/account-rrsp.svg',
  'First Home Savings Account (FHSA / CELIAPP)': '/logos/account-fhsa.svg',
  'Registered Education Savings Plan (RESP / REEE)': '/logos/account-resp.svg',
};

/**
 * Get logo path for an institution name.
 * Falls back to null if no logo found.
 */
export function getLogoPath(institutionName) {
  if (!institutionName) return null;
  return LOGO_MAP[institutionName] || null;
}
